import React, { useContext, useEffect, useRef, useState } from 'react'
import './Navbar.css'
import cart_icon from '../Assets/cart_icon.png'
import { Link } from 'react-router-dom'
import { ShopContext } from '../../Context/ShopContext'
import nav_dropdown from '../Assets/nav_dropdown.png'
import { onAuthStateChanged, signOut } from 'firebase/auth'
import { auth } from '../../firebase'

const Navbar = () => {

    const [menu, setMenu] = useState("vp")
    const [user, setUser] = useState(null)

    const { getTotalCartItems } = useContext(ShopContext)
    const menuRef = useRef()

    useEffect(() => {

        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser)
        })

        return () => unsubscribe()

    }, [])

    const dropdown_toggle = (e) => {
        menuRef.current.classList.toggle('nav-menu-visible')
        e.target.classList.toggle('open')
    }

    const handleLogout = async () => {

        try {

            await signOut(auth)
            window.location.replace('/')

        } catch (error) {

            console.error('Logout error:', error)

        }

    }

    return (
        <div className='navbar'>

            <Link
    to='/'
    style={{
        textDecoration: 'none',
        color: 'inherit'
    }}
>
    <div className="nav-logo">
        <p>BadtameezDil <span>GameStore</span></p>
    </div>
</Link>

            <img
                className='nav-dropdown'
                onClick={dropdown_toggle}
                src={nav_dropdown}
                alt="Menu"
            />

            <ul ref={menuRef} className='nav-menu'>

                <li onClick={() => { setMenu("vp") }}>
                    <Link
                        style={{ textDecoration: 'none' }}
                        to='/valorant-vp'
                    >
                        Valorant VP
                    </Link>

                    {menu === "vp" ? <hr /> : <></>}
                </li>

                <li onClick={() => { setMenu("accounts") }}>
                    <Link
                        style={{ textDecoration: 'none' }}
                        to='/valorant-accounts'
                    >
                        Valorant Accounts
                    </Link>

                    {menu === "accounts" ? <hr /> : <></>}
                </li>
                <li onClick={() => { setMenu("reviews") }}>
    <Link
        style={{ textDecoration: 'none' }}
        to='/reviews'
    >
        Reviews
    </Link>

    {menu === "reviews" ? <hr /> : <></>}
</li> 

            </ul>

            <div className='nav-login-cart'>

                {user ? (

                    <button onClick={handleLogout}>
                        Logout
                    </button>

                ) : (

                    <Link to='/login'>
                        <button>Login</button>
                    </Link>

                )}

                <Link to='/cart'>
                    <img src={cart_icon} alt="Cart" />
                </Link>

                <div className='nav-cart-count'>
                    {getTotalCartItems()}
                </div>

            </div>

        </div>
    )
}

export default Navbar

